import templateUrl from "emun.on-demand/admin/download-images-prompt.htm";
import DownloadImagesPromptController from "emun.on-demand/admin/download-images-prompt.controller";
import open from "webmodals/open";

export default options =>
  open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    controller: DownloadImagesPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  }).result;
